// https://vuex.vuejs.org/en/state.html

export default {
  baseUrl: JSON.parse(localStorage.getItem("baseUrl") || "null") || {
    name: "",
    domain: ""
  }
};
